import { Templates } from "../../web/src/ui/Templates";

export interface FacebookEventLIData {
	title:string;
	eventUrl:string;
	startTime:string;
	description:string;
}

export class FacebookEventLI {
	public data:FacebookEventLIData;
	public ui:HTMLLIElement;

	constructor(data: FacebookEventLIData) {
		this.data = data;
		this._init();
	}

	private _init(): void {
		this.ui = Templates.createElement(facebookEventLITemplate) as
			HTMLLIElement;

		let titleDiv = this.ui.querySelector(".stscr-cli-title") as
			HTMLDivElement;
		let dateDiv = this.ui.querySelector(".stscr-cli-date") as
			HTMLDivElement;
		let descDiv = this.ui.querySelector(".stscr-cli-description") as
			HTMLDivElement;
		let joinAnchor = this.ui.querySelector(".stscr-cli-join") as
			HTMLAnchorElement;

		titleDiv.innerText = this.data.title;
		dateDiv.innerHTML = `<span>When: </span>${this.data.startTime}`;

		let cleanedDesc = this._cleanDescription(this.data.description);
		let formattedDesc = cleanedDesc.replace(/\n/g, "<br/>");
		descDiv.innerHTML = `<span>Details: </span>${formattedDesc}`;
		joinAnchor.href = this.data.eventUrl;
	}

	private _cleanDescription(desc: string): string {
		if (!desc) {
			return "";
		}
		let cleaned = desc.replace(
			/https?:\/\/(www\.)?facebook\.com\/events\/\d+\/?/g,
			""
		);
		return cleaned.trim();
	}
}

const facebookEventLITemplate = `
<li class="splide__slide">
	<div class="stscr-communityLI stscr-eventLI showJoin">
		<div class="stscr-cli-top">
			<div class="stscr-cli-title"></div>
			<div class="stscr-cli-details">
				<div class="stscr-cli-date"></div>
				<div class="stscr-cli-description"></div>
			</div>
		</div>
		<div class="stscr-cli-bottom">
			<a class="stscr-cli-join" target="_blank" rel="noopener noreferrer">
				View Event & RSVP
			</a>
		</div>
	</div>
</li>
`;
